    import { blog1, blog2, blog3, blog4, blog5, blog6, blog7, blog8, blog9, blog10, blog11, blog12, blog13, blog14, blog15, blog16, blog17, student_blog1, student_blog2, student_blog3, student_blog4, new_student_blog_1, new_educator_blog_1, new_educator_blog_2 } from "../../../assets/images";

    
    // export const blogPosts = [
    //     {
    //         title: "From Overwhelmed to Empowered: How AI is Transforming Professors' Lives Across Campus",
    //         date: "July 17, 2025",
    //         imageUrl: blog1,
    //         blogId:"1",
    //     },
    //     {
    //         title: "How AI-based Chatbots Are Changing the Student Experience on Campus",
    //         date: "July 20, 2025",
    //         imageUrl: blog2,
    //         blogId:"2",
    //     },

    //     {
    //         title: "Increasing Student Retention with Campus Insights. Turning Engagement into Completion",
    //         date: "July 23, 2025",
    //         imageUrl: blog3,
    //         blogId:"3",
    //     },
    //     {
    //         title: "Boosting Student Recruitment with Campus Insights. AI-Powered Engagement That Converts",
    //         date: "August 1, 2025",
    //         imageUrl: blog4,
    //         blogId:"4",
    //     },
    //     {
    //         title: "The AI Campus Revolution: How Smart Technology is Reshaping Higher Education",
    //         date: "August 3, 2025",
    //         imageUrl: blog5,
    //         blogId:"5",
    //     },
    //     {
    //         title: "From Stress to Success: How AI-Powered Support Eases Campus Pressure",
    //         date: "August 5, 2025",
    //         imageUrl: blog6,
    //         blogId:"6",
    //     },

    //     {
    //         title: "Best Practices for Using SMS in Campus Insights. Engaging Students Where They Are ...",
    //         date: "August 6, 2025",
    //         imageUrl: blog7,
    //         blogId:"7",
    //     },
    //     {
    //         title: "Multilingual Support in Campus Insights",
    //         date: "August 7, 2025",
    //         imageUrl: blog8,
    //         blogId:"8",
    //     },
    //      {
    //         title: " Keeping Your Campus Website Accurate, Trusted, and Effective with the Site Integrity Report",
    //         date: "August 9, 2025",
    //         imageUrl: blog9,
    //         blogId:"9",
    //     },
    //      {
    //         title: "Smart Forms: Simplifying Form Completion for Students, Faculty, and Staff",
    //         date: "August 15, 2025",
    //         imageUrl: blog10,
    //         blogId:"10",
    //     },
    //      {
    //         title: "Campus Insights Admin Dashboard: Your Command Center for Smarter Campus Decisions",
    //         date: "August 17, 2025",
    //         imageUrl: blog11,
    //         blogId:"11",
    //     },
    //     {
    //         title: "Fill Smarter, Save Bigger: How AI Autofill Puts Money Back in Students’ Pockets",
    //         date: "September 25, 2025",
    //         imageUrl: blog12,
    //         blogId:"12",
    //     },
    //     {
    //         title: "Leading the Future of Learning: Why LXP Is a Strategic Win for Higher Education",
    //         date: "September 29, 2025",
    //         imageUrl: blog13,
    //         blogId:"13",
    //     },
    //     {
    //         title: "Teaching in the Age of Intelligence: Why LXP Is a Game-Changer for Educators",
    //         date: "September 30, 2025",
    //         imageUrl: blog14,
    //         blogId:"14",
    //     },
    //     {
    //         title: "Don’t Let Missed Forms Cost You: How Smart Forms Saves Students Time and Money",
    //         date: "October 05, 2025",
    //         imageUrl: blog15,
    //         blogId:"15",
    //     },
    //     {
    //         title: "Smart Forms by Campus Insights",
    //         date: "October 07, 2025",
    //         imageUrl: blog16,
    //         blogId:"16",
    //     },
    //     {
    //         title: "Why First-Year Retention Is the Canary in the Coal Mine for College Enrollment",
    //         date: "October 07, 2025",
    //         imageUrl: blog17,
    //         blogId:"17",
    //     }
    // ];


export const blogPosts = [
  // ===== LXP Blogs =====
  {
    title: "How AI‑Powered LMS Tools Empower Educators to Improve Student Performance and Support On‑Time Graduation",
    date: "19 May 2026",
    imageUrl: new_educator_blog_2,
    blogId: "24",
    type: "ai-lms",
    objectPosition: "top",
  },
  {
    title: "Faculty at the Frontline of the AI Shift",
    date: "09 April 2026",
    imageUrl: new_educator_blog_1,
    blogId: "23",
    type: "ai-lms",
    objectPosition: "top",
  },
  {
    title: "Why First-Year Retention Is the Canary in the Coal Mine for College Enrollment",
    date: "October 07, 2025",
    imageUrl: blog17,
    blogId: "17",
    type: "ai-lms",
  },
  {
    title: "Teaching in the Age of Intelligence: Why LXP Is a Game-Changer for Educators",
    date: "September 30, 2025",
    imageUrl: blog14,
    blogId: "14",
    type: "ai-lms",
  },
  {
    title: "Leading the Future of Learning: Why LXP Is a Strategic Win for Higher Education",
    date: "September 29, 2025",
    imageUrl: blog13,
    blogId: "13",
    type: "ai-lms",
  },
  {
    title: "From Stress to Success: How AI-Powered Support Eases Campus Pressure",
    date: "August 5, 2025",
    imageUrl: blog6,
    blogId: "6",
    type: "ai-lms",
  },
  {
    title: "The AI Campus Revolution: How Smart Technology is Reshaping Higher Education",
    date: "August 3, 2025",
    imageUrl: blog5,
    blogId: "5",
    type: "ai-lms",
  },
  {
    title: "Boosting Student Recruitment with Campus Insights. AI-Powered Engagement That Converts",
    date: "August 1, 2025",
    imageUrl: blog4,
    blogId: "4",
    type: "ai-lms",
  },
  {
    title: "Increasing Student Retention with Campus Insights. Turning Engagement into Completion",
    date: "July 23, 2025",
    imageUrl: blog3,
    blogId: "3",
    type: "ai-lms",
  },
  {
    title: "From Overwhelmed to Empowered: How AI is Transforming Professors’ Lives Across Campus",
    date: "July 17, 2025",
    imageUrl: blog1,
    blogId: "1",
    type: "ai-lms",
  },


  // ===== LXP Blogs (Students) =====
  {
    title: "AI Is Changing Everything. Are You Ready?",
    date: "09 April 2026",
    imageUrl: new_student_blog_1,
    blogId: "22",
    type: "ai-lms-students",
  },
  {
    title: "From Stress to Success: How AI Rebuilt My Study Life",
    date: "19 January 2026",
    imageUrl: student_blog4,
    blogId: "21",
    type: "ai-lms-students",
  },
  {
    title: "Why Students Should Make the Most of an LXP Student Portal",
    date: "09 January 2026",
    imageUrl: student_blog1,
    blogId: "18",
    type: "ai-lms-students",
  },
  {
    title: "The Financial Benefits of Using an LXP Student Portal",
    date: "09 January 2026",
    imageUrl: student_blog2,
    blogId: "19",
    type: "ai-lms-students",
  },
  {
    title: "Saving Time with an LXP Student Portal",
    date: "09 January 2026",
    imageUrl: student_blog3,
    blogId: "20",
    type: "ai-lms-students",
  },

  // ===== AI Assistant Blogs =====
  {
    title: "Fill Smarter, Save Bigger: How AI Autofill Puts Money Back in Students’ Pockets",
    date: "September 25, 2025",
    imageUrl: blog12,
    blogId: "12",
    type: "ai-assistant",
  },
  {
    title: "Campus Insights Admin Dashboard: Your Command Center for Smarter Campus Decisions",
    date: "August 17, 2025",
    imageUrl: blog11,
    blogId: "11",
    type: "ai-assistant",
  },
  {
    title:
      "Keeping Your Campus Website Accurate, Trusted, and Effective with the Site Integrity Report",
    date: "August 9, 2025",
    imageUrl: blog9,
    blogId: "9",
    type: "ai-assistant",
  },
  {
    title: "Multilingual Support in Campus Insights",
    date: "August 7, 2025",
    imageUrl: blog8,
    blogId: "8",
    type: "ai-assistant",
  },
  {
    title: "Best Practices for Using SMS in Campus Insights. Engaging Students Where They Are ...",
    date: "August 6, 2025",
    imageUrl: blog7,
    blogId: "7",
    type: "ai-assistant",
  },
  {
    title: "How AI-based Chatbots Are Changing the Student Experience on Campus",
    date: "July 20, 2025",
    imageUrl: blog2,
    blogId: "2",
    type: "ai-assistant",
  },

  // ===== Smart Forms Blogs =====
  {
    title: "Smart Forms by Campus Insights",
    date: "October 07, 2025",
    imageUrl: blog16,
    blogId: "16",
    type: "smart-forms",
  },
  {
    title: "Don’t Let Missed Forms Cost You: How Smart Forms Saves Students Time and Money",
    date: "October 05, 2025",
    imageUrl: blog15,
    blogId: "15",
    type: "smart-forms",
  },
  {
    title: "Smart Forms: Simplifying Form Completion for Students, Faculty, and Staff",
    date: "August 15, 2025",
    imageUrl: blog10,
    blogId: "10",
    type: "smart-forms",
  },

];

